import type { SelectedFilter } from '../api/rest/types';
import type { SelectedFilterValue } from '../types';

export const useSpecialCategoryFilter = (selectedFilters: SelectedFilter[]) => {
  const categoryFilter = selectedFilters.find((filter) => filter.isCategoryFilter);

  return {
    selectedCategoryFilterValues:
      categoryFilter && categoryFilter.groupedValues[0].values[0]
        ? [
            {
              filterId: categoryFilter.id,
              selectedValues: [categoryFilter.groupedValues[0].values[0].id],
            } satisfies SelectedFilterValue,
          ]
        : [],
  };
};
